import React, { useEffect, useState, Suspense, Component } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ColorProvider } from './context/ColorContext';
import Header from './components/Header';
import Home from './pages/Home';
import VideoPortfolio from './pages/VideoPortfolio';
import PhotoPortfolio from './pages/PhotoPortfolio';
import MotionDesignPortfolio from './pages/MotionDesignPortfolio';
import ProjectDetail from './pages/ProjectDetail';
import InteractiveBackground from './components/InteractiveBackground';
import Footer from './components/Footer';
import Impressum from './pages/Impressum';
class ErrorBoundary extends Component<{
  children: React.ReactNode;
}, {
  hasError: boolean;
  error: Error | null;
}> {
  constructor(props: {
    children: React.ReactNode;
  }) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }
  static getDerivedStateFromError(error: Error) {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return <div className="flex items-center justify-center min-h-screen" data-id="element-0">
          <div className="text-center" data-id="element-1">
            <h1 className="text-2xl font-bold mb-4" data-id="element-2">Something went wrong</h1>
            <p className="text-gray-600 mb-4" data-id="element-3">{this.state.error?.message}</p>
            <button onClick={() => window.location.reload()} className="px-4 py-2 bg-blue-500 text-white rounded-lg" data-id="element-4">
              Reload page
            </button>
          </div>
        </div>;
    }
    return this.props.children;
  }
}
const AnimatedRoutes = () => {
  const location = useLocation();
  const getBackgroundColor = () => {
    if (location.pathname.includes('/video')) {
      return 'bg-indigo-50/20';
    } else if (location.pathname.includes('/photo')) {
      return 'bg-rose-50/20';
    } else if (location.pathname.includes('/motion')) {
      return 'bg-teal-50/20';
    }
    return 'bg-gray-50/10';
  };
  return <>
      <div className={`min-h-screen ${getBackgroundColor()} transition-colors duration-700`} data-id="element-5">
        <div className="relative" data-id="element-6">
          <InteractiveBackground data-id="element-7" />
          <div className="relative" data-id="element-8">
            <Header data-id="element-9" />
            <main className="container mx-auto px-4 pt-32 pb-24" data-id="element-10">
              <AnimatePresence mode="wait" initial={false} data-id="element-11">
                <Routes location={location} key={location.pathname} data-id="element-12">
                  <Route path="/" element={<Home data-id="element-14" />} data-id="element-13" />
                  <Route path="/video" element={<VideoPortfolio data-id="element-16" />} data-id="element-15" />
                  <Route path="/photo" element={<PhotoPortfolio data-id="element-18" />} data-id="element-17" />
                  <Route path="/motion" element={<MotionDesignPortfolio data-id="element-20" />} data-id="element-19" />
                  <Route path="/project/:slug" element={<ProjectDetail data-id="element-22" />} data-id="element-21" />
                  <Route path="/impressum" element={<Impressum data-id="element-24" />} data-id="element-23" />
                </Routes>
              </AnimatePresence>
            </main>
            <Footer data-id="element-25" />
          </div>
        </div>
      </div>
    </>;
};
export function App() {
  return <ErrorBoundary data-id="element-26">
      <ColorProvider data-id="element-27">
        <BrowserRouter data-id="element-28">
          <AnimatedRoutes data-id="element-29" />
        </BrowserRouter>
      </ColorProvider>
    </ErrorBoundary>;
}